import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

export const PanelSpinner = () => {
  return (
    <div style={{height: "100%", width: "100%", display: "block"}}>
      <CircularProgress color="primary" style={spinnerStyle}/>
    </div>
  )          
}


const spinnerStyle = {
  position: "absolute", 
  top: "50%", 
  left: "50%", 
  transform: "translate(-50%, -50%)",
  marginLeft: -20,
  marginTop: -20,
}